import React from 'react';
import style from '../../style/about.module.css';
import photo from '../../assets/profile-photo.jpeg';
import {
  js, 
  htmlcss, 
  python, 
  react, 
  cpp, 
  sql} from '../../assets/icons';

function About() {

  return (
    <div id="About" className={style.about}>
      <div className={style.intro}>
        <img className={style.photo} src={photo} alt="lily-yang-profile-photo"></img>
        <h1><span className={style.wave}>👋</span>hello world!<br /> i am lily</h1>
        <p>
          An <span className={`${style.keywords} ${style.aspiring}`}>aspiring tech savvy personnel</span> studying at BCIT. I don't want to <span className={`${style.keywords} ${style.conquer}`}>conquer the world</span> but I just want a role that will let me learn every single day and provide support to end users or internal stakeholders. Be it <span className={`${style.keywords} ${style.support}`}>IT support</span>, <span className={`${style.keywords} ${style.sysAdmin}`}>System Administrator</span>, <span className={`${style.keywords} ${style.devops}`}> Devops Engineer</span>, or <span className={`${style.keywords} ${style.supportSpe}`}>Technical Support Specialist</span>. 
        </p>

        <p>
          I also recently fell <span className={`${style.keywords} ${style.aspiring}`}>in love with Networking and Operating Systems</span> so I am studying and learning a lot of theorectical concepts on my own outside of class and building projects to demonstrate my learnings. 😍
        </p>
      </div>
      <Skill />
    </div>
  )
}

function Skill() {
  
  const skills = [
    { 
      name: "Javascript",
      logo: js
    },
    {
      name: "Python",
      logo: python
    },
    {
      name: "C++",
      logo: cpp 
    },
    {
      name: "React",
      logo: react
    },
    {
      name: "HTML/CSS",
      logo: htmlcss
    },
    {
      name: "MYSQL",
      logo: sql
    }]

  return (
    <div className={style.skills}>
      <h3>Skills highlight</h3>
      <div className={style.skillList}>
        <div>
       {skills.map((skill, index) => <SkillItem key={index} content={skill}/>)}
        </div>
      </div>
    </div>
  ) 
}

function SkillItem({content}) {
  return <div className={style.skillItem}>
    <img src={content.logo} />
    <p>{content.name}</p>
    </div>
}


export default About;